import UserAvatar from 'src/Components/NavBar/UserAvatar';

import styles from './ExpenseItem.module.scss';
import { Props } from './ExpenseItem.types';

const ExpenseItem = ({ username, amount, user, badge, subtitle }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.user}>
        {user && <UserAvatar user={user} size="md" />}
        <div className={styles.identity}>
          <div className={styles.name}>{username}</div>
          {subtitle}
        </div>
        {badge}
      </div>
      <div className={styles.amount}>{`${amount}€`}</div>
    </div>
  );
};

export default ExpenseItem;
